import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ProductsService } from "../../app/products/service";
import { ErrorToast, SuccessToast } from "../toasters/toasters";
import { ConfirmDelete } from "./ConfirmDelete";
import { useState } from "react";
import { t } from "i18next";

export const SortableItem = ({
  img,
  onDelete,
  onDownload,
  setCurrentProduct,
}: {
  img: any;
  onDelete: (img: any) => void;
  onDownload: (img: any) => void;
  setCurrentProduct: any;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: img.id });

  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<any>(null);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  // For images
  const handleDeleteImage = () => {
    if (!selectedImage?.id) return;
    ProductsService.deleteImageById(selectedImage.id)
      .then(() => {
        setCurrentProduct((prev: any) => ({
          ...prev,
          productPictures: prev.productPictures.filter(
            (i: any) => i.id !== selectedImage.id
          ),
        }));
        setOpenModal(false);
        SuccessToast(
          `${t("toasts.successfully_deleted")} ${
            selectedImage?.file?.nameOriginal
          }`
        );
        onDelete(selectedImage);
      })
      .catch((error) => ErrorToast(error));
  };

  // For documents and videos
  const handleDeleteFile = () => {
    if (!selectedImage?.id) return;
    ProductsService.deleteFile(selectedImage.id)
      .then(() => {
        setCurrentProduct((prev: any) => ({
          ...prev,
          [selectedImage.fileType === "document" ? "documents" : "videos"]:
            prev[
              selectedImage.fileType === "document" ? "documents" : "videos"
            ].filter((f: any) => f.id !== selectedImage.id),
        }));
        setOpenModal(false);
        SuccessToast(
          `${t("toasts.successfully_deleted")} ${
            selectedImage?.file?.nameOriginal
          }`
        );
        onDelete(selectedImage);
      })
      .catch((error) => ErrorToast(error));
  };

  return (
    <>
      <li
        ref={setNodeRef}
        style={style}
        {...attributes}
        className="list-group-item d-flex justify-content-between align-items-center cursor-auto"
      >
        <span {...listeners} style={{ cursor: "grab", marginRight: "8px" }}>
          <i className="ri-drag-move-2-line" />
        </span>

        <div className="flex-grow-1">
          <a
            href={img.path}
            target="_blank"
            rel="noopener noreferrer"
            className="file-link"
          >
            {img.file?.nameOriginal || img.file?.name || img.path}
          </a>
        </div>

        <div className="base-data-btn-group">
          <button
            className="btn btn-sm btn-outline-primary me-2"
            onClick={(e) => {
              e.stopPropagation();
              onDownload(img);
            }}
          >
            <i className="ri-download-2-line" />
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(img); // spremi trenutno selektovanu
              setOpenModal(true); // otvori modal
            }}
          >
            <i className="ri-delete-bin-line" />
          </button>
        </div>
      </li>

      <ConfirmDelete
        show={openModal}
        setShow={setOpenModal}
        itemName={selectedImage?.file?.nameOriginal}
        deleteHandler={
          !selectedImage?.fileType || selectedImage?.fileType === "image"
            ? handleDeleteImage
            : handleDeleteFile
        }
        selectedProduct={selectedImage}
      />
    </>
  );
};
